import { useCallback, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import qs from 'qs'

const useRouter = () => {
    const history = useHistory()
    const { search, pathname } = useLocation()

    const queryParams = useMemo(() => qs.parse(search, { ignoreQueryPrefix: true }), [search])
    const replaceQueryParam = useCallback(
        (key, value) => {
            history.replace({
                pathname,
                search: qs.stringify({ ...queryParams, [key]: value }),
            })
        },
        [history, pathname, queryParams],
    )

    return {
        pathname,
        historyPush: data => history.push(data),
        queryParams,
        addQueryParam: (key, value) => {
            history.push({
                pathname,
                search: qs.stringify({ ...queryParams, [key]: value }),
            })
        },
        replaceQueryParam,
        removeQueryParam: (...keys) => {
            history.push({
                pathname,
                search: qs.stringify({
                    ...queryParams,
                    ...keys.reduce((acc, key) => ({ ...acc, [key]: undefined }), {}),
                }),
            })
        },
    }
}

export default useRouter
